module.exports = __webpack_public_path__ + "img/logo-23.6ba7209.jpg";